module.exports = __webpack_public_path__ + "static/media/hair (20).84a3e945.jpg";